/**
 * Created by Administrador on 31/10/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('passengerManifestCtrl', passengerManifestCtrl);

    passengerManifestCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService', 'airports', 'flightService',
        'linkService','reportService'];

    function passengerManifestCtrl($stateParams, tabs, datePickerService, airports, flightService, linkService, reportService){
        var vm = this;

        vm.tabs = tabs;
        vm.airports = airports;
        vm.flights = [];
        vm.report = undefined;
        vm.departureDate = new Date();
        vm.orderBys = [
            {
                "name": "Pasajero",
                "value": "pax"
            },
            {
                "name": "Numero Asiento",
                "value": "seat"
            }
        ];

        vm.dateParam = $stateParams.date;
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            }
        };

        vm.predicate = 'pax';
        vm.reverse = 'asc';
        vm.getGeneralManifest = getGeneralManifest;
        vm.transition = transition;

        function transition() {
            getGeneralManifest();
        }

        function getGeneralManifest () {
            reportService.getGeneralManifest(vm.flight.departureFlightId,'general',vm.flight.flightId,vm.flight.departureFlightOrder, vm.predicate)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        vm.report = response.data;
                    }
                });
        }

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.eventChangeOrigin = function(){
            vm.report = undefined;
            if(vm.departureDate != undefined && vm.originAirport != undefined /*&& vm.orderBy != undefined*/){
                vm.flights= [];
                flightService.getFlightByDepartureDateAndOrigin(vm.departureDate.getTime(),linkService.getLinkId(vm.originAirport._links.self.href))
                    .then(function (response) {
                        angular.forEach(response, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                departureFlightId: linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href),
                                route: flight._embedded.route.initials,
                                departureFlightOrder: flight._embedded.departureflights[0].order,
                                flightId: linkService.getLinkId(flight._links.self.href)
                            });
                        });
                    });
            }
        }

        vm.eventChangeFlight = function(){
            vm.report = undefined;
            if(vm.flight != undefined/* && vm.orderBy != undefined*/){
                reportService.getGeneralManifest(vm.flight.departureFlightId,'passenger',vm.flight.flightId,vm.flight.departureFlightOrder,vm.predicate)
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }

        vm.exportPdf = function(reducedPrint){
            reportService.getPassengerManifestPdf(vm.flight.departureFlightId,reducedPrint,vm.predicate)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "passenger_manifest_"+(reducedPrint?"r":"n")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }
    }
})();
